import BaseModelAPI from '../BaseModelAPI';

export default class Area extends BaseModelAPI {
	static entity = 'area';
	static entityName = 'area';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.partClassificationId = '';
			this.partClassification = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}